import React from "react";
import { Wifi, WifiOff, AlertTriangle } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const MAP = {
  online: { key: "status.online", cls: "text-emerald-700 bg-emerald-50 border-emerald-200", icon: Wifi },
  warning: { key: "status.warning", cls: "text-amber-700 bg-amber-50 border-amber-200", icon: AlertTriangle },
  offline: { key: "status.offline", cls: "text-slate-600 bg-slate-100 border-slate-300", icon: WifiOff },
};

export const StatusBadge = ({ status, testid }) => {
  const { t } = useI18n();
  const s = MAP[status] || MAP.offline;
  const Icon = s.icon;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}
    >
      <Icon className="h-3 w-3" strokeWidth={2} />
      {t(s.key)}
    </span>
  );
};

export const SeverityBadge = ({ severity }) => {
  const { t } = useI18n();
  const cls =
    severity === "critical"
      ? "text-rose-700 bg-rose-50 border-rose-200"
      : "text-amber-700 bg-amber-50 border-amber-200";
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${cls}`}>
      {severity === "critical" ? t("alerts.critical") : t("alerts.warning")}
    </span>
  );
};
